import React, { useState } from 'react';

const images = [
  { src: "/images/doc01.jpg", alt: "Project 1" },
  { src: "/images/doc02.jpg", alt: "Project 2" },
  { src: "/images/doc03.jpg", alt: "Project 3" },
  { src: "/images/doc04.jpg", alt: "Project 4" },
  { src: "/images/doc05.jpg", alt: "Project 5" },
  { src: "/images/doc06.jpg", alt: "Project 6" },
  { src: "/images/doc07.jpg", alt: "Project 7" },
  { src: "/images/doc08.jpg", alt: "Project 8" },
  { src: "/images/doc09.jpg", alt: "Project 9" },
  { src: "/images/doc10.jpg", alt: "Project 10" },
  { src: "/images/doc11.jpg", alt: "Project 11" },
  { src: "/images/doc12.jpg", alt: "Project 12" },
  { src: "/images/doc13.jpg", alt: "Project 13" },
  { src: "/images/doc14.jpg", alt: "Project 14" }



  // Add more images here later
];

function Gallery({ language }) {
  const [selectedImage, setSelectedImage] = useState(null);
  const t = (en, id) => language === 'en' ? en : id;

  return (
    <div className="gallery-page">
      <div className="gallery-header">
        <h1>{t('Gallery', 'Galeri')}</h1>
        <p>
          {t('Our Premium Projects & Completed Works', 'Proyek Premium & Hasil Pekerjaan Kami')}
        </p>
      </div>

      <div className="gallery-grid">
        {images.map((img, index) => (
          <div 
            key={index} 
            className="gallery-item"
            onClick={() => setSelectedImage(img)}
          >
            <img src={img.src} alt={img.alt} loading="lazy" />
            <div className="overlay">
              <span>View Project</span>
            </div>
          </div>
        ))}
      </div>

      {/* Lightbox */}
      {selectedImage && (
        <div className="lightbox" onClick={() => setSelectedImage(null)}>
          <div className="lightbox-content" onClick={e => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setSelectedImage(null)}>✕</button>
            <img src={selectedImage.src} alt={selectedImage.alt} />
          </div>
        </div>
      )}
    </div>
  );
}

export default Gallery;